<template>
  <div>
    <!-- Índice Original para Desktop/Tablet -->
    <div class="is-hidden-mobile">
      <ul class="steps has-content-centered">
        <li class="steps-segment" v-for="(tab, key) in tabs" :class="{ 'is-active': tab.isActive }" :key="key">
          <span class="steps-marker"></span>
          <div class="steps-content">
            <p v-if="tab.isActive" class="is-size-5 tab-name">
              {{ tab.name }}
            </p>
          </div>
        </li>
      </ul>
    </div>

    <!-- Novo Índice para Mobile -->
    <div class="mobile-steps-indicator is-hidden-tablet mb-4">
      <div class="indicator-visuals">
        <span class="dot" :class="{ 'is-active': currentActive === 0 }"></span>
        <span class="line" :class="{ 'is-active': currentActive > 0 }"></span> 
        <!-- Adicionar mais pontos/linhas conforme necessário ou usar v-for -->
        <!-- Simplificação inicial com 1 ponto e 1 linha -->
      </div>
      <p class="step-text">Etapa {{ currentActive + 1 }} de {{ totalTabs }}</p>
    </div>

    <div class="tab-details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { useAppStore } from "@/stores/AppStore";

export default {
  name: 'form-wizard',

  data() {
    return {
      tabs: [],
      currentActive: 0,
      totalTabs: 0
    }
  },

  created() {
    this.tabs = this.$children
  },

  mounted() {
    this.totalTabs = this.tabs.length
  },

  methods: {
    previousTab(skip = 1) {
      this.currentActive-=skip
      const appStore = useAppStore()

      appStore.openReviewSideBar = !(this.currentActive <= 2 || this.currentActive >= 8);
      this.tabs.forEach(tab => {
        tab.isActive = false
      })
      this.tabs[this.currentActive].isActive = true
    },

    nextTab(plusPages = 1) {
      //Validate input
      this.$root.$validator.validate('step' + (this.currentActive + plusPages)+'.*').then(valid => {
        if (valid) {
          this.currentActive += plusPages
          const appStore = useAppStore()
          appStore.openReviewSideBar = !(this.currentActive <= 2 || this.currentActive >= 8);

          this.tabs.forEach(tab => {
            tab.isActive = false
          })

          this.tabs[this.currentActive].isActive = true
        }
      })
    },

    submit() {
      this.$root.$validator.validate('step'+this.totalTabs+'.*').then(valid => {
        if (valid) {
          alert("Everything passes ! Ready to Submit")
        }
      })
    }
  },
  computed: {
    isBlackNovember() {
      return process.env.VUE_APP_IS_BLACK_NOVEMBER
    }
  }
  
}
</script>

<style lang="scss">

$grey: #dae6ec;
$light-grey: #f0f0f0; // Cor para a linha inativa
$tablet: 769px; // Definindo breakpoint para tablet

// Estilos para o índice original (Desktop/Tablet)
.is-hidden-mobile {
  .steps:not(.is-hollow) .steps-segment.is-active ~ .steps-segment .steps-marker:not(.is-hollow) {
    background-color: $grey!important;
    color: rgba(0, 0, 0, 0.7);
  }

  .steps {
    // Mantém os estilos originais para desktop/tablet aqui se necessário
    // ou remove os estilos mobile que estavam antes
  }

  .tab-name {
    color: var(--primary-color);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Segoe UI, Arial, sans-serif;
    max-width: none; 
    min-width: 6rem; 
    font-size: 1rem; 
  }
}

// Estilos para o NOVO índice (Mobile)
.mobile-steps-indicator {
  display: flex;
  align-items: center;
  justify-content: space-between; // Coloca a barra/ponto à esquerda e o texto à direita
  padding: 0 1rem; // Adiciona algum espaçamento lateral

  .indicator-visuals {
    display: flex;
    align-items: center;
    
    .dot {
      width: 8px;
      height: 8px;
      background-color: $light-grey; // Cor inativa
      border-radius: 50%;
      margin-right: 5px; // Espaço entre ponto e linha
      transition: background-color 0.3s ease;

      &.is-active {
        background-color: var(--primary-color); // Cor ativa
      }
    }

    .line {
      width: 40px; // Largura da linha
      height: 4px;  // Altura/espessura da linha
      background-color: $light-grey; // Cor inativa
      border-radius: 2px;
      transition: background-color 0.3s ease;
      
      // A lógica de ativação da linha pode precisar ser ajustada
      // Aqui, ela fica azul se a etapa atual for maior que 0 (ou seja, não a primeira)
      &.is-active {
         background-color: var(--primary-color); // Cor ativa
      }
      // Para múltiplas etapas, a lógica aqui precisaria ser mais complexa (talvez com v-for)
    }
  }

  .step-text {
    color: #7a7a7a; // Cor cinza para o texto
    font-size: 0.9rem;
    white-space: nowrap; // Evita quebra de linha
  }
}

</style>